var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.items,"item-text":"title","item-value":"id"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }